// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3Z6Lj","right":"styles_right__3GMJF"};